import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch } from '../../hooks';
import { TUserSignUp, userSignUp } from '../../store/AuthSlice/AuthApi';
import FullScreenLoader from '../../components/Loaders/FullScreenloader';

const deviceTimeZone =
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Singapore';

const QuickSignUp: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const searchParams = new URLSearchParams(location.search);

  const name = searchParams.get('name') || '';
  const email = searchParams.get('email') || '';
  const phoneNumber = searchParams.get('phoneNumber') || '';
  const curriculum = searchParams.get('curriculum') || '';

  useEffect(() => {
    if (name && email && phoneNumber) {
      const apiData: TUserSignUp = {
        name,
        phoneNumber,
        email: email.toLowerCase().trim(),
        timezone: deviceTimeZone,
        clientId: process.env.REACT_APP_TUTOPIYA_CLIENT_ID || '',
        clientSecret: process.env.REACT_APP_TUTOPIYA_CLIENT_SECRET || '',
      };

      if (curriculum) {
        apiData.curriculum = curriculum;
      }

      dispatch(userSignUp(apiData));
    }
  }, []);

  return (
    <div>
      <FullScreenLoader />
    </div>
  );
};

export default QuickSignUp;
